<script>
import Swal from 'sweetalert2';
import { convertCurrency } from '~/assets/js/methods';

export default {
    name: 'HeaderSinglePage',
    props: ['checkoutCustom', 'orderbumpUncheck'],
    emits: ['toggleSumary'],
    setup() {
        return {
            convertCurrency
        }
    },
    computed: {
        getCart() {
            return this.$store.getters['getCart']
        }
    },
    watch: {
        getCart: {
            async handler(e) {
                let body = {
                    customer: this.$store.getters['getCustomer'],
                    store_hash: this.$store.getters['getStore'].hash,
                    cart: e,
                    payment_method: this.$store.getters['getPaymentMethodSelected']
                };

                try {
                    const data = await fetch(`${this.$config.URL_API}/checkout/coupons/check`, {
                        method: 'POST',
                        body: JSON.stringify(body),
                        headers: {
                            "Content-Type": "application/json",
                            "Accept": "application/json",
                        }
                    });

                    const res = await data.json();

                    if (res?.enable_coupons) {
                        this.$store.commit("setAutomaticCoupons", res.enable_coupons);
                    }

                    const autoApplyCoupon = res.enable_coupons.find(coupon => coupon.auto_apply_in_checkout === 1);

                    if (autoApplyCoupon) {
                        this.$store.commit("setCoupon", autoApplyCoupon);

                        Swal.fire({
                            icon: 'success',
                            title: 'Cupom adicionado com sucesso!',
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 3000,
                            timerProgressBar: true,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        });
                    } else if (typeof res.coupon_applyed !== 'undefined' && res.coupon_applyed !== null) {
                        if (!this.$store.getters['getCoupon']) {
                            this.$store.commit("setCoupon", res.coupon_applyed);

                            Swal.fire({
                                icon: 'success',
                                title: 'Cupom adicionado com sucesso!',
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 3000,
                                timerProgressBar: true,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', Swal.stopTimer)
                                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                                }
                            });
                        }
                    }
                } catch (error) {
                    this.$store.commit("setCoupon", "");
                }
            },
            immediate: true
        }

    },
    methods: {
        toggleSumaryCallback(){
            this.toggleSumary = !this.toggleSumary;
            this.$emit('toggleSumary', this.toggleSumary)
        }
    },
    mounted() {
        if (window.location.hostname === 'unicopag.com.br' || 
        window.location.hostname === 'www.unicopag.com.br' || 
        window.location.hostname === 'https://unicopag.com.br' || 
        window.location.hostname === 'https://www.unicopag.com') {
            window.location.href = 'https://unicopag.com';
        }
    },
    data(){
        return {
            toggleSumary: this.toggleSumary
        }
    }
}
</script>


<template>
    <header class="clearfix">
    </header>
</template>